// Module
var code = "<canvas></canvas> ";
// Exports
export default code;